import axios from 'axios'
import Vue from 'vue'

let axiosImage = axios.create({
    baseURL: 'https://apodaca2.rciempaquesplegadizos.com:8181/',

  })


export async function subirImagen(context, payload){
    try{
        context.commit('setLoading',true,{root:true})//lanzamos el loading
        const url = "https://apodaca2.rciempaquesplegadizos.com:8181/api/uploadimage"
        
        const values = new FormData()
        values.append('image',payload.image)
        values.append('id',payload.id)
        values.append('token',payload.token)

        const response = await axios.post(url, values);
        
        context.commit('setPath',response.data)
    }
    catch(error){
      
        context.commit('imageError', error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}// subirImagen

export async function savePath(context, payload){
    try{
        context.commit('setLoading',true,{root:true})//lanzamos el loading
        const url = "api/pathImage"
        
        const values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        values.append('id',payload.id)
        values.append('images',JSON.stringify(payload.images))

        await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })
    }
    catch(error){
      
        context.commit('imageError', error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}